<template>
  <section class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-5-tablet is-4-desktop is-3-widescreen">
          <img src="/app/LoneWorker.uk.png" alt="LoneWorker.uk">
          <div v-if="!loaded">
            Loading...
          </div>
          <div v-else>
            <div v-if="flash" class="box has-background-info has-text-white mt-4">
              {{ flash }}</div>
            <div v-else>
              <div v-if="uid">
                <div v-if="sessid">
                  <div class="box">
                    <div class="title has-text-centered">
                      <div :class="{ 'has-text-danger': countdown < 1 }">
                        {{ countdownText }}
                      </div>
                      <div v-if="countdownAlarmState == 1"
                        class="box has-background-info has-text-white has-text-centered my-4">
                        Less than a minute to go, please extend or end this session</div>
                      <div v-if="countdownAlarmState == 11"
                        class="box has-background-danger has-text-white has-text-centered my-4">
                        WARNING
                      </div>
                    </div>
                    <div>
                      Started: {{ sess.Start.toLocaleString() }}
                    </div>
                    <div>
                      Ends: {{ sess.End.toLocaleString() }}
                    </div>

                    <button class="button is-fullwidth is-primary mt-5" @click="handleExtendSession(15)">Extend 15
                      mins</button>
                    <button class="button is-fullwidth is-primary mt-5" @click="handleExtendSession(30)">Extend 30
                      mins</button>
                    <button class="button is-fullwidth is-primary mt-5" @click="handleExtendSession(60)">Extend 1
                      hour</button>

                    <button class="button is-fullwidth is-info mt-5" @click="handleEndSession()">End session</button>
                  </div>
                </div>
                <div v-else>
                  <div class="mb-2">
                    Select your expected duration to start your loneworker session.
                  </div>
                  <div class="field">
                    <button class="button is-fullwidth is-info" @click="handleDuration(60)">1 Hour</button>
                  </div>
                  <div class="field">
                    <button class="button is-fullwidth is-info" @click="handleDuration(90)">1 &half; Hours</button>
                  </div>
                  <div class="field">
                    <button class="button is-fullwidth is-info" @click="handleDuration(120)">2 Hours</button>
                  </div>
                  <div class="field">
                    <button class="button is-fullwidth is-info" @click="handleDuration(150)">2 &half; Hours</button>
                  </div>
                  <div class="field">
                    <button class="button is-fullwidth is-info" @click="handleDuration(180)">3 Hours</button>
                  </div>
                  <div class="field">
                    <select class="select is-fullwidth" @change="handleDuration($event.target.value)">
                      <option value="0">-- Select other duration --</option>
                      <option value="2">2 Minutes</option>
                      <option value="5">5 Minutes</option>
                      <option value="10">10 Minutes</option>
                      <option value="15">15 Minutes</option>
                      <option value="30">30 Minutes</option>
                      <option value="45">45 Minutes</option>
                      <option value="60">1 hour</option>
                      <option value="90">1 &half; hours</option>
                      <option value="120">2 hours</option>
                      <option value="150">2 &half; hours</option>
                      <option value="180">3 hours</option>
                      <option value="240">4 hours</option>
                      <option value="300">5 hours</option>
                      <option value="360">6 hours</option>
                      <option value="420">7 hours</option>
                      <option value="480">8 hours</option>
                      <option value="720">12 hours</option>
                      <option value="960">16 hours</option>
                      <option value="1200">20 hours</option>
                      <option value="1440">24 hours</option>
                      <option value="2880">48 hours</option>
                      <option value="4320">72 hours</option>
                    </select>
                  </div>
                </div>
                <div class="mt-3">
                  <div v-if="showInfo">
                    <p class="mb-2">After selecting your expected duration, our automated system will wait for you to
                      end your session.</p>
                    <p class="mb-2"> If you close this page, don't worry you'll still be protected, and you can open it
                      again
                      by scanning the QR code or tapping your phone on the same poster you checked-in with.</p>
                    <p class="mb-2">A few minutes before your session is due to end, we'll give you a reminder call.</p>
                    <div class="mb-2">
                      To save having to enter your details again should you use this system again, we've remember them
                      for you, but if you would like us to forget them, just <a @click="handleClear()">click here</a>
                    </div>
                    <button class="button" @click="showInfo = false">Hide</button>
                  </div>
                  <div v-else>
                    <button class="button" @click="showInfo = true">More information?</button>
                  </div>
                </div>
              </div>
              <div v-else v-cloak>
                <div class="box has-background-info has-text-white">
                  Looks like you're new here? We just need a few details to get you started.
                </div>
                <div class="field">
                  <label class="label">Mobile number</label>
                  <input type="tel" class="input" v-model="user.tel">
                  <small>So we can contact you if needed</small>
                </div>
                <div class="field">
                  <label class="label">Name</label>
                  <input type="text" class="input" v-model="user.name">
                </div>
                <div class="field">
                  <label class="label">Email (optional)</label>
                  <input type="email" class="input" v-model="user.email">
                  <small>We'll email you with a summary of your visit</small>
                </div>
                <div>
                  <button class="button is-primary is-fullwidth" @click="handleSubmit()">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="mt-2">
      <button class="button is-small" @click="showDebug = !showDebug">Show/hide debug</button>
    </div>
    <div class="content">
      <ul v-if="showDebug" class="ul">
        <li v-for="(d, index) in debug" :key="index">{{ d }}</li>
      </ul>
    </div> -->
  </section>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      showDebug: false,
      debug: [],
      loaded: true,
      uid: null,
      sid: null,
      sessid: null,
      sess: null,
      duration: null,
      user: {
        tel: "",
        name: "",
        email: "",
      },
      flash: "",
      flashTimer: null,
      showInfo: false,
      countdown: null,
      countdownTimer: null,
      countdownAlarmState: 0,
    }
  },
  computed: {
    countdownText() {
      let mins;
      if (this.countdown > -1) {
        mins = Math.floor(this.countdown / 60)
      } else {
        mins = Math.ceil(this.countdown / 60)
      }
      let secs = this.countdown % 60
      if (secs < 0) {
        secs = -secs
      }
      if (mins == 0) {
        return `${secs} secs`
      }
      return `${mins} mins ${secs} secs`
    }
  },
  mounted() {
    this.uid = localStorage.getItem("UID") || ""
    this.log(`UID from localstorage '${this.uid}'`)
    if (this.uid) {
      // Check UID is a valid user
      fetch(`/api/checkuser/${this.uid}`).then(resp => {
        this.log(`Checkuser return '${resp.status}'`)
        if (resp.status == 200) {
          const id = localStorage.getItem("SESSID") || ""
          this.log(`SESSID from localstorage '${id}'`)
          if (id) {
            this.getSession(id).then(() => {
              this.loaded = true
            })
          } else {
            this.loaded = true
          }
        } else {
          this.uid = null
          this.loaded = true
        }
      })
    }
    this.loaded = true
    // if (location.search.length > 1) {
    //   console.log(location.search)
    // }
  },
  methods: {
    log(text) {
      this.debug.unshift(text)
    },
    getSession(id) {
      return new Promise((resolve) => {
        fetch(`/api/session/${id}`).then(resp => {
          this.log(`GetSession '${id}' returned ${resp.status}`)
          if (resp.status == 200) {
            resp.json().then(sess => {
              this.sessid = id
              this.sess = sess
              this.sess.Start = new Date(this.sess.Start)
              this.sess.End = new Date(this.sess.End)
              this.startCountdownTimer()
              resolve()
            })
          }
        })
      })
    },
    startCountdownTimer() {
      this.log(`StartCountdownTimer()`)
      const now = new Date().getTime() / 1000
      this.countdown = Math.round(this.sess.End / 1000 - now)

      this.countdownTimer = setInterval(() => {
        const now = new Date().getTime() / 1000
        const end = this.sess.End.getTime() / 1000
        this.countdown = Math.round(end - now)
        if (this.countdown < 60 && this.countdownAlarmState == 0) {
          this.log(`Countdown state is now 1`)
          this.countdownAlarmState = 1
          this.beep()
        }
        if (this.countdown < 0 && this.countdownAlarmState < 11) {
          this.log(`Countdown state is now 11`)
          this.countdownAlarmState = 11
        }
      }, 1000)
    },
    setFlash(text) {
      if (this.flashTimer) {
        clearTimeout(this.flashTimer)
      }
      this.flash = text
      this.flashTimer = setTimeout(() => this.flash = "", 1500)
    },
    handleExtendSession(d) {
      fetch(`/api/session/${this.sessid}`, { method: 'post', body: JSON.stringify({ extend: d }) }).then(resp => {
        if (resp.status == 200) {
          resp.text().then(() => {
            this.getSession(this.sessid)
          })
        }
      })
    },
    handleDuration(d) {
      if (d) {
        this.duration = parseInt(d)
      }
      if (this.duration > 0) {
        let data = {
          sid: this.sid,
          uid: this.uid,
          mins: this.duration,
        }
        fetch('/api/checkin', { method: 'post', body: JSON.stringify(data) }).then(resp => {
          this.log(`Checkin '${data}' returned ${resp.status}`)
          if (resp.status == 200) {
            resp.json().then(sess => {
              localStorage.setItem("SESSID", sess.SessID)
              this.getSession(sess.SessID)
            })
          }
        })
      }
    },
    handleClear() {
      localStorage.clear()
      this.uid = null
      this.sessid = null
      this.sess = null
    },
    handleEndSession() {
      const id = this.sessid
      if (!id) {
        alert("No session to end!")
        return
      }
      fetch(`/api/session/${id}`, { method: 'delete' }).then(resp => {
        if (resp.status == 200 || resp.status == 400) {
          localStorage.removeItem("SESSID")
          this.sessid = null
          this.countdownAlarmState = 0
          this.log(`Countdown state is now 0`)
          clearInterval(this.countdownTimer)
          this.log(`CountdownTimer closed`)
          this.setFlash("Session ended")
        }
      })

    },
    handleSubmit() {
      fetch('/api/newuser', { method: 'post', body: JSON.stringify(this.user) }).then(resp => {
        if (resp.status == 200) {
          resp.text().then(uid => {
            localStorage.setItem("UID", uid)
            this.uid = uid
            this.setFlash("Thank you!")
          })
        }
      })
    },
    beep() {
      try {
        var snd = new Audio("data:audio/wav;base64,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");
        snd.play();
      } catch (e) {
        console.log("Error playing beep", e)
      }
    },
  }
}
</script>

<style>
</style>
